import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-help-questions',
    templateUrl: './help-questions.component.html',
    styleUrls: ['./help-questions.component.css'],
    standalone: false
})
export class HelpQuestionsComponent implements OnInit {

  constructor() {

  }

  ngOnInit(): void {

  }

}
